function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.eliminaricon{fill:#243165;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "WEVjhE.tif_00000095298581373317358380000003117007535519303340_",
  transform: "translate(-291.514 96.001)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_353_00000008830047197908665400000016761016912446005903_"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_614_00000067217802601046520420000011205671761409367735_",
  className: "eliminaricon",
  d: "M304-92.6c1.5-1.2,2.9-1.3,3.9-0.3 c1,1,1,2.3-0.3,3.9c1,1,2,2,3.1,3c0.4,0.3,0.5,0.9,0.2,1.3c0,0,0,0.1-0.1,0.1c-0.4,0.2-0.8,0.4-1.2,0.4c-0.2,0-0.4-0.2-0.5-0.4 c-3.2-3.2-6.4-6.3-9.5-9.5c-0.5-0.4-0.5-1-0.2-1.5c0,0,0,0,0.1-0.1c0.5-0.4,1.2-0.4,1.6,0.1c0,0,0,0,0,0 C302.1-94.6,303-93.6,304-92.6z M304.9-91.8l1.9,1.8c0.2-0.5,0.5-0.9,0.4-1.3c-0.1-0.4-0.4-0.8-0.8-0.9 C306-92.3,305.5-92,304.9-91.8L304.9-91.8z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_352_00000039134018032472820120000000932660098107880861_"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_615_00000070824635214245309570000009728451435577228707_",
  className: "eliminaricon",
  d: "M303.3-88c-3.2,0-6.4,0-9.6,0 c-1.1-0.1-2,0.6-2.1,1.7c0,0.2,0,0.5,0.1,0.7c0.6,4.2,1.1,8.4,1.7,12.6c0.1,1.1,1,2,2.2,2c0,0,0,0,0.1,0c1,0,2,0,3.1,0 c1,0,2.1,0,3.1,0c1.1,0.1,2.1-0.8,2.2-1.9c0,0,0,0,0,0c0.6-4.1,1.1-8.3,1.7-12.4C305.7-87.1,305-87.9,303.3-88z M296.3-72.9 c-0.9,0.1-1.7-0.6-1.7-1.5c0,0,0,0,0,0c-0.4-3.3-0.9-6.5-1.3-9.8c-0.2-0.8,0.3-1.6,1.1-1.8c0.2,0,0.4-0.1,0.5,0 c0.8,0,2.2,0,2.9,0l0.4,13.2C297.8-72.9,296.7-72.9,296.3-72.9L296.3-72.9z M304.1-84.1c-0.4,3.2-0.9,6.5-1.3,9.7 c0,0.9-0.8,1.5-1.7,1.5c0,0,0,0,0,0c-0.4,0-1.5,0-1.9,0l0.4-13.2c0.7,0,2.1,0,2.8,0C303.7-86.1,304.3-85.4,304.1-84.1L304.1-84.1 z"
}))));

var SvgEliminar = function SvgEliminar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.6 25",
    style: {
      enableBackground: "new 0 0 19.6 25"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEliminar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eliminar.3bf093fd.svg";
export { ForwardRef as ReactComponent };